module.exports = __webpack_public_path__ + "img/sm.cd7d92cc.svg";